import React from 'react'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Footer from '../Footer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import Wrapper from '../Wrapper'
import './index.css'
import globalConfig from '../../../config/globalConfig'

const PublicLayout = ({ title, children }) => {
  const feature = useSelector(state => state?.tenant?.license || [])
  const tenant = useSelector(state => state?.tenant?.tenant || {})

  return (
    <Wrapper>
      <div className='container-login'>
        <div className='side-left px-4'>
          <div className='school-logo'>
        <img src={`${globalConfig.storage}${tenant.logoUrl}`} alt='institute_logo' />
          </div>
          <div className='side-left-container relative'>
            <div className='maestro-logo'></div>
            <div className='feature-license'>
              {feature.filter(item => !item.isDefault).map((item) => (
                <div key={`feature-license-${item._id}`} className='flex items-center justify-center gap-2 text-secondary'>
                  <FontAwesomeIcon icon={["fas", "circle-check"]} className='feature-license-item' />
                  <span className='feature-license-item text-nowrap'>{item.name}</span>
                </div>
              ))}
            </div>
            <Footer />
          </div>
        </div>

        <div className='side-right'>
          <Paper className='side-right-container'>
            <div className='side-right-subcontainer'>
              <Grid container spacing={3} alignItems='center'>
                <Grid item xs={12}>
                  <Typography className='text-main color-primary-blue text-bold'>{title}</Typography>
                </Grid>
                {children}
              </Grid>
            </div>
          </Paper>
        </div>
      </div>
    </Wrapper>
  )
}

export default PublicLayout;
